<template>
    <span class="statement__table-mobile-head-txt">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: "TableMobileHeader"
};
</script>

<style lang="scss" scoped>
.statement__table-mobile-head-txt {
    width: 30%;
    text-align: left;
    padding: 16px;
}

@media (max-width: 812px) {
    .statement__table-mobile-head-txt {
        font-size: 14px;
        width: 32%;
        padding: 10px 5px;
    }
}

@media (max-width: 812px) {
    .statement__table-mobile-head-txt:first-child {
        padding-left: 16px;
    }
}

@media (max-width: 812px) {
    .statement__table-mobile-head-txt:last-child {
        padding-right: 18px;
    }
}
</style>
